export const container = "c1fqir43";
export const divider = "d13q86v6";
export const grid = "g4398g2";
export const faqs = "f16ubx42";
export const resourcesContainer = "rtm3y3d";
export const resourcesParent = "r2p8d2u";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");